import { CountUp } from 'countup.js';
import $ from 'jquery';

const easeOutExpo = (t, b, c, d) =>
	t === d ? b + c : c * (-(2 ** ((-10 * t) / d)) + 1) + b;

export default class CounterAnimation {
	startAnimation(counterElements) {
		counterElements.each((index, element) => {
			const counterItem = $(element);
			const countUp = new CountUp(element, counterItem.attr('data-target'), {
				duration: 3,
				easingFn: easeOutExpo,
				separator: counterItem.hasClass('use-seperator') ? '.' : '',
			});
			countUp.start();
		});
	}
}
